import styled from 'styled-components';
import {
  Typography,
} from '@mui/material';

import colors from '../../../../../../../styles/colors';

const Text = styled(Typography)`
  margin-bottom: 5px;
`;

const FormInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  min-height: 80px;
`;

const InputLabel = styled(Text)`
  font-size: 13px;
  margin-bottom: 8px;
  font-weight: 500;
  color: ${colors.shades.gamma10};
  line-height: 1.4;
`;

export {
  FormInputContainer,
  InputLabel,
};
